// extracted by mini-css-extract-plugin
export default {"client-sublayer":"ClientSublayer_client-sublayer__KgyIy"};